'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _CwPodCol = require('./CwPodCol.scss');

var _CwPodCol2 = _interopRequireDefault(_CwPodCol);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwPodCol = function CwPodCol(props) {
  var getSectionHeader = function getSectionHeader() {
    if (props.sectionHeader || props.ghostSectionHeader) {
      return _react2.default.createElement(
        'div',
        { className: (0, _classnames2.default)(_CwPodCol2.default.sectionHeader, (0, _defineProperty3.default)({}, _CwPodCol2.default.ghostSectionHeader, props.ghostSectionHeader)) },
        props.ghostSectionHeader ? 'expect(jkenoyer).toBeFalsy()' : props.sectionHeader,
        props.sectionHeaderElements
      );
    }

    return null;
  };

  return _react2.default.createElement(
    'div',
    { style: { flexGrow: props.colSpan },
      className: (0, _classnames2.default)(_CwPodCol2.default.podCol, props.sectionHeader ? _CwPodCol2.default.podColWithSectionHeader : _CwPodCol2.default.podColWithoutSectionHeader, props.className) },
    getSectionHeader(),
    props.children
  );
};

CwPodCol.propTypes = {
  sectionHeader: _propTypes2.default.string,
  ghostSectionHeader: _propTypes2.default.bool,
  sectionHeaderElements: _propTypes2.default.arrayOf(_propTypes2.default.element),
  colSpan: _propTypes2.default.number,
  children: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.arrayOf(_propTypes2.default.element)]),
  className: _propTypes2.default.string
};

CwPodCol.defaultProps = {
  colSpan: 1
};

exports.default = CwPodCol;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwpod/CwPodCol.js
// module id = 375
// module chunks = 10